import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import siteContextService from '@/b2c/shared/site-context.service';
import { computed } from 'vue';
import authStore from '@/shared/auth/auth.store';
import siteContextStore from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLink',
  setup(__props) {


const isSPAEnabled = computed(() => {
    if (authStore.isSignedInAsStore) {
        return true;
    }
    return siteContextService.isNewCheckOutEnabled;
});

const basketPageUrl = computed(() => {
    return siteContextStore.settings.basketPageUrl;
});


return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!

  return (_openBlock(), _createBlock(_component_RouterLinkConditional, {
    "spa-enabled": _unref(isSPAEnabled),
    to: _unref(basketPageUrl)
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["spa-enabled", "to"]))
}
}

})